<script setup lang="ts">
import {computed, type HTMLAttributes} from 'vue'
import {
  DialogContent,
  type DialogContentEmits,
  type DialogContentProps,
  DialogOverlay,
  DialogPortal,
  useForwardPropsEmits,
} from 'radix-vue'
import {cn} from '@/lib/utils'
import {dialogContentVariant, type DialogContentVariants} from '.'

const props = withDefaults(defineProps<DialogContentProps & {
  class?: HTMLAttributes['class'],
  overlay?: DialogContentVariants['overlay'],
  content?: DialogContentVariants['content']
}>(), {
  overlay: 'default',
  content: 'default'
})
const emits = defineEmits<DialogContentEmits>()

const delegatedProps = computed(() => {
  const {class: _, ...delegated} = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DialogPortal>
    <DialogOverlay
      :class="cn(dialogContentVariant({overlay}), 'fixed inset-0 z-[62] bg-[rgba(0,0,0,0.6)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0')"
    />
    <DialogContent
      v-bind="forwarded"
      @openAutoFocus.prevent
      :class="
        cn(
            dialogContentVariant({content}),
          'fixed overflow-hidden border-0 border-gray-50 bg-popover left-1/2 top-1/2 z-[63] flex flex-col w-full max-w-lg max-h-[80svh] -translate-x-1/2 -translate-y-1/2 duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] rounded-2xl focus:outline-none focus-visible:!outline-0',
          props.class,
        )"
    >
      <slot/>
    </DialogContent>

  </DialogPortal>
</template>
